
  // ハンバーガーメニューボタンがクリックされたときのイベントハンドラを設定
  $(".hamburgerIcon").click(function () {

    // 現在のbodyタグのoverflowスタイルを確認
    if ($("body").css("overflow") === "hidden") {

      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("body").css({ height: "", overflow: "" });

    } else {

      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("body").css({ height: "100%", overflow: "hidden" });

    }
  });

  $(".closebtn").click(function () {

    // 現在のbodyタグのoverflowスタイルを確認
    if ($("body").css("overflow") === "hidden") {

      // もしoverflowがhiddenなら、bodyのスタイルを元に戻す
      $("body").css({ height: "", overflow: "" });

    } else {

      // そうでなければ、bodyにheight: 100%とoverflow: hiddenを設定し、スクロールを無効にする
      $("body").css({ height: "100%", overflow: "hidden" });

    }
  });

document.addEventListener("DOMContentLoaded", function () {
  const ctaBanner = document.querySelector(".oem-tab");
  const footer = document.querySelector("footer"); // フッター要素を指定

  function toggleActiveClass() {
    const scrollPosition = window.scrollY;
    const footerPosition = footer.offsetTop; // フッターのページ上の位置
    const windowHeight = window.innerHeight;

    if (scrollPosition + windowHeight < footerPosition) {
      // フッター手前で非表示
      ctaBanner.classList.remove("remove");
    } else {
      ctaBanner.classList.add("remove");
    }
  }

  window.addEventListener("scroll", toggleActiveClass);
});




 if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
    
  } else {
  }

window.addEventListener('pageshow', (e) => {
   if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
  if (e.persisted) {
    window.location.reload();
  }
   };
});


var headNav = $("header");
    $(window).on('load scroll', function () {
        if($(this).scrollTop() > 500 && headNav.hasClass('fixed') == false) {
            headNav.css({"top": '-100px'});
            headNav.addClass('fixed');
            headNav.animate({"top": 0},600);
        }
        else if($(this).scrollTop() < 300 && headNav.hasClass('fixed') == true){
            headNav.removeClass('fixed');
        }
    });


$('#meisai1').change(function() {
     var meisai = $('option:selected').val();
     if(meisai=="同梱しない"){
       $('#meisai2').css('background', 'rgb(197 197 197)');
        $('#meisai2').css('pointer-events', 'none');
     }
     if(meisai=="同梱する"){
       $('#meisai2').css('background', '#ffffff');
        $('#meisai2').css('pointer-events', 'visible');
     }
    });



    
$('.delete').click(function(e) {
    $('.oem-tab').css('display', 'none');
});

$('.qa-list .question').click(function () {
    $(this).toggleClass("active");
    $(this).nextAll(".answer").slideToggle();
  });

  $('.hamburgerIcon').click(function () {
    $(this).toggleClass("active");
    $(".nav-box").toggleClass("active");
  });
  $('.closebtn').click(function () {
    $('.hamburgerIcon').toggleClass("active");
    $(".nav-box").toggleClass("active");
  });



var cate_swiper = new Swiper(".popular-slide", {
    slidesPerView: "auto",
    spaceBetween: 12,
    // simulateTouch: false,
    loop: true,
    loopAdditionalSlides  : 1,
    speed: 4500,
  freeMode: false,
      freeModeSticky: true,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    breakpoints: {
      820: {
        // spaceBetween: 50,
      },
    },
  });


 var swiper = new Swiper(".top-swiper", {
  centeredSlides: true,
    slidesPerView: "auto",
    spaceBetween: 13,
    freeMode: false,
      freeModeSticky: true,
      autoplay:true,
      loop: true,
          breakpoints: {
            1000: {
              spaceBetween: 25,
            },
            768: {
              spaceBetween: 25,
            },
          },
  });

  var swiper = new Swiper(".product-swiper1", {
    slidesPerView: 1.25,
    spaceBetween: 24,
    freeMode: false,
      freeModeSticky: true,
      loop: false,
          breakpoints: {
            1000: {
              spaceBetween: 25,
            },
            768: {
              spaceBetween: 25,
            },
          },
  });
  var swiper = new Swiper(".product-swiper2", {
    slidesPerView: 1.25,
    spaceBetween: 24,
    freeMode: false,
      freeModeSticky: true,
      loop: false,
          breakpoints: {
            1000: {
              spaceBetween: 25,
            },
            768: {
              spaceBetween: 25,
            },
          },
  });



